/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import React from "react";
import { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
} from "@mui/material";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@mui/material/Divider";
import Swal from "sweetalert2";
import ListItemButton from "@mui/material/ListItemButton";
import axios from "axios";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LogoutIcon from "@mui/icons-material/Logout";
import { loginState, configState } from "../lib/State";
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import NoteIcon from '@mui/icons-material/Note';

function Layout(props) {  
  
  const {login} = props
  const ccid = login.ccid;

  const onLogout = () => {
    Swal.fire({
      title: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      sconfirmButtonText: "예",
      cancelButtonText: "아니오",
      closeOnCalcel: true,
    }).then((result) => {
      if (result.isConfirmed == true) {
        localStorage.setItem("token", "");
        window.location.href = "/";
      }
    });
  };

  const onGoMember = () => {
    window.location.href = "/member";
  };

  const onGoHome = () => {
    window.location.href = "/home";
  };

  const goBand = () => {
    window.location.href = "/band";
  };

  const onHrClick = async () => {    
    let result = await axios.post(configState.api + "/hr/get_kiosk_id",{ccid:ccid});
    let kiosk_id = result.data.kiosk_id;
    if (kiosk_id === undefined || kiosk_id === "") {
      Swal.fire("인증실패, 다시 로그인 하세요.");
      return;
    }   
    localStorage.setItem("token", ""); // 로그아웃
    window.location.href="/hr?ccid=" + ccid + "&kiosk_id=" + kiosk_id;
  };

  const onGoKiosk = async () => {
    let result = await axios.post(configState.api + "/hr/get_kiosk_id",{ccid:ccid});
    let kiosk_id = result.data.kiosk_id;
    if (kiosk_id === undefined || kiosk_id === "") {
      Swal.fire("인증실패, 다시 로그인 하세요.");
      return;
    }
    localStorage.setItem("token", ""); // 로그아웃
    window.location.href="/user?ccid=" + ccid + "&kiosk_id=" + kiosk_id;
  };

  return (
    <Box
      css={css`
        display: flex;
        height: 100vh;
      `}
    >
      <Box
        css={css`
          display: flex;
          flex-direction: column;
          width: 240px;
        `}
      >
        <Box
          css={css`
            background: #3396f4;
            height: 50px;
            display: flex;
            align-items: center;
          `}
        >
          <div
            css={css`
              margin-left: 10px;
              color: white;
              font-size: 20px;
              font-weight: bold;
            `}
          >
            대시보드
          </div>
        </Box>

        <Box
          css={css`
            flex: 1;
            border-right: 1px solid #e0e0e0;
          `}
        >
          <ListItemButton onClick={onGoHome}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="대시보드" />
          </ListItemButton>
          <ListItemButton onClick={onGoMember}>
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="회원관리" />
          </ListItemButton>
          <ListItemButton onClick={goBand}>
            <ListItemIcon>
              <NoteIcon />
            </ListItemIcon>
            <ListItemText primary="밴드관리" />
          </ListItemButton>          
          <ListItemButton onClick={onHrClick}>
            <ListItemIcon>
              <AdUnitsIcon />
            </ListItemIcon>
            <ListItemText primary="심박 프로그램" />
          </ListItemButton>
          <ListItemButton onClick={onGoKiosk}>
            <ListItemIcon>
              <AdUnitsIcon />
            </ListItemIcon>
            <ListItemText primary="회원 프로그램"/>
          </ListItemButton>
          <Box
            css={css`
              height: 40px;
            `}
          ></Box>
          <Divider />
          <Box
            sx={{
              bgcolor: "rgba(71, 98, 130, 0.2)",
              pb: 0,
            }}
          >
            <ListItemButton>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="로그아웃" onClick={onLogout} />
            </ListItemButton>
          </Box>
        </Box>
      </Box>
      <Box
        css={css`
          flex: 1;
          display: flex;
          flex-direction: column;
        `}
      >
        <Box
          css={css`
            background: #3396f4;
            height: 50px;
          `}
        >
          &nbsp;
        </Box>
        <Box
          css={css`
            padding-left: 15px;
          `}
        >
          {props.children}
        </Box>
      </Box>
    </Box>
  );
}
export default Layout;
